
import { Component, Vue, Prop} from 'vue-property-decorator';

import StepBase from "../StepBase.vue";
import { stepInfoType } from "@/types/Application";

import PoQuestionnaire from "./PoQuestionnaire.vue";
import YourInformationPo from "./YourInformationPO.vue";
import OtherParty from "./otherPartyComponent/OtherParty.vue";

import ProtectionFromWhom from "./ProtectionFromWhom.vue";
import PoFilingLocation from "./PoFilingLocation.vue";
import RemovePerson from "./safetyNeeds/RemovePerson.vue";
import NoGo from "./safetyNeeds/NoGo.vue";
import NoContact from "./safetyNeeds/NoContact.vue";
import WeaponsFirearms from "./safetyNeeds/WeaponsFirearms.vue";
import Background from "./Background.vue";
import YourStory from "./YourStory.vue";

import About from "./About.vue";
import Urgency from "./Urgency.vue";

import ReviewYourAnswers from "./reviewPo/ReviewYourAnswers.vue"
import PreviewForms from "./reviewPo/PreviewForms.vue"

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

@Component({
    components:{
        StepBase,
        PoQuestionnaire,        
        YourInformationPo,
        OtherParty,

        ProtectionFromWhom,
        PoFilingLocation,
        RemovePerson,
        NoGo,
        NoContact,
        WeaponsFirearms,
        Background,
        YourStory,

        About,
        Urgency,

        ReviewYourAnswers,
        PreviewForms,
    }
})

export default class StepProtectionOrder extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;
    
}
